<template>
  <div>
    <v-container fluid>
      <v-layout row>
        <v-flex>
          <v-slide-y-transition mode="out-in">
            <slot />
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  props: ['title']
}
</script>
